import { render, staticRenderFns } from "./TopUpTip.vue?vue&type=template&id=4c8acb22&scoped=true"
import script from "./TopUpTip.vue?vue&type=script&lang=js"
export * from "./TopUpTip.vue?vue&type=script&lang=js"
import style0 from "./TopUpTip.vue?vue&type=style&index=0&id=4c8acb22&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8acb22",
  null
  
)

export default component.exports